import Button from '@admin/components/button'
import { Check } from 'lucide-react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import React from 'react'

class Plan extends React.Component {

  static propTypes = {
    has_website: PropTypes.bool,
    is_chosen: PropTypes.bool,
    period: PropTypes.string,
    plan_type: PropTypes.object,
    plan: PropTypes.object,
    onChoose: PropTypes.func
  }

  render() {
    const { plan_type, period, onChoose } = this.props
    const features = this._getFeatures()
    return (
      <div className={ this._getClass() } onClick={ onChoose }>
        <div className="maha-manage-plan-plan-title">{ plan_type.title }</div>
        <div className="maha-manage-plan-plan-price">{ this._getPrice() }<span>/mo</span></div>
        <div className="maha-manage-plan-plan-period">(billed { period })</div>
        <div className="maha-manage-plan-plan-description">
          <div className="maha-manage-plan-plan-features" dangerouslySetInnerHTML={ { __html: features.title } } />
          { features.items.map((item,index) => (
            <p key={`feature_${index}`}>
              <Check strokeWidth={ 4 } /> { item }
            </p>
          )) }
        </div>
      </div>
    )
  }

  _getFeatures() {
    const { has_website, plan_type } = this.props
    return (has_website ? plan_type.website_features : null) || plan_type.features
  }

  _getClass() {
    const { is_chosen } = this.props
    const classes = ['maha-manage-plan-plan']
    if(is_chosen) classes.push('chosen')
    return classes.join(' ')
  }

  _getPrice() {
    const { plan, period } = this.props
    return numeral(period === 'yearly' ? plan.price / 12 : plan.price).format('$0')
  }
  
}

export default Plan